"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _luxon = require("luxon");

var _SplitLineSeries = _interopRequireDefault(require("../SplitLineSeries"));

var _colors = require("../../constants/colors");

var _chartUtils = require("../../chartUtils");

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _ChartStyles = require("../ChartStyles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var gridLineStyle = {
  stroke: _colors.CHARCOAL,
  strokeWidth: 0.5
};
var lineSeriesStyle = {
  stroke: _colors.BLUE,
  strokeWidth: 1,
  fill: 'none'
};

var getYearTicks = function getYearTicks(startDateTime, endDateTime) {
  var startYear = startDateTime.startOf('year');
  var endYear = endDateTime.startOf('year');
  var numberOfYears = endYear.diff(startYear, 'years').years;
  var startOfYears = [];

  for (var i = 0; i <= numberOfYears; i += 1) {
    startOfYears.push(startYear.plus({
      years: i
    }));
  }

  return startOfYears.map(function (y) {
    return y.toMillis();
  });
};

var Display = /*#__PURE__*/function (_PureComponent) {
  _inherits(Display, _PureComponent);

  var _super = _createSuper(Display);

  function Display() {
    _classCallCheck(this, Display);

    return _super.apply(this, arguments);
  }

  _createClass(Display, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          delta = _this$props.delta,
          fieldServiceActivity = _this$props.fieldServiceActivity,
          maxDate = _this$props.maxDate,
          meterReadings = _this$props.meterReadings,
          minDate = _this$props.minDate,
          timeZone = _this$props.timeZone,
          unit = _this$props.unit;
      var meterCoordinates = meterReadings.filter((0, _chartUtils.isValidReading)('solar')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'solar'));
      var minDateMillis = minDate.toMillis();
      var maxDateMillis = maxDate.toMillis();
      var yearTicks = getYearTicks(minDate, maxDate);
      var fsaCoordinates = (0, _readingsToCoordinates.fieldServiceActivityToCoordinates)(fieldServiceActivity, timeZone);
      return /*#__PURE__*/_react["default"].createElement(_ChartStyles.ChartContainer, null, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
        xType: "time",
        xDomain: [minDateMillis, maxDateMillis],
        height: 100,
        margin: {
          top: 0,
          bottom: 0
        },
        dontCheckIfEmpty: true
      }, /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
        margin: {
          top: 20,
          bottom: 30
        },
        marginLeft: 25,
        marginRight: 25,
        curve: "curveBasis",
        data: meterCoordinates,
        delta: delta,
        style: lineSeriesStyle,
        unit: unit
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
        hideLine: true,
        orientation: "top",
        style: {
          fontSize: '12px',
          fontFamily: 'sans-serif',
          ticks: {
            line: {
              display: 'none',
              opacity: 0
            }
          }
        },
        tickFormat: function tickFormat(t) {
          return /*#__PURE__*/_react["default"].createElement("text", {
            transform: "translate(10, 20)",
            style: {
              userSelect: 'none'
            }
          }, "".concat(_luxon.DateTime.fromMillis(t, {
            zone: timeZone
          }).toFormat('yyyy')));
        },
        tickValues: yearTicks
      }), /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalGridLines, {
        tickValues: yearTicks,
        style: gridLineStyle
      })), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
        xType: "time",
        xDomain: [minDateMillis, maxDateMillis],
        height: 100,
        margin: {
          top: 0,
          bottom: 0
        },
        yDomain: [0, 100]
      }, /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalRectSeries, {
        className: "minimap__field-service-activity__series",
        data: fsaCoordinates,
        marginLeft: 25,
        marginRight: 25,
        style: {
          fill: _colors.FADED_GREY,
          stroke: _colors.FADED_GREY,
          opacity: 0.7
        }
      }))));
    }
  }]);

  return Display;
}(_react.PureComponent);

Display.propTypes = {
  delta: _propTypes["default"].number,
  fieldServiceActivity: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    actionCodeName: _propTypes["default"].string,
    actionId: _propTypes["default"].string,
    actionName: _propTypes["default"].string,
    caseId: _propTypes["default"].string,
    caseNumber: _propTypes["default"].string,
    closedDate: _propTypes["default"].string,
    componentCode: _propTypes["default"].string,
    componentCodeName: _propTypes["default"].string,
    createdDate: _propTypes["default"].string,
    dispatchFindings: _propTypes["default"].string,
    dispatchId: _propTypes["default"].string,
    dispatchName: _propTypes["default"].string,
    dispatchTime: _propTypes["default"].string,
    origin: _propTypes["default"].string,
    reason: _propTypes["default"].string,
    serviceContractName: _propTypes["default"].string,
    status: _propTypes["default"].string,
    subsetReason: _propTypes["default"].string
  })),
  maxDate: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  meterReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    solar: _propTypes["default"].number,
    timestamp: _propTypes["default"].string
  })),
  minDate: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  timeZone: _propTypes["default"].string,
  unit: _propTypes["default"].string
};
Display.defaultProps = {
  delta: 1,
  fieldServiceActivity: [],
  meterReadings: [],
  timeZone: '',
  unit: 'day'
};
var _default = Display;
exports["default"] = _default;